export const HOME = '/'
export const CONTACT = '/contact'
export const GALLERY = '/gallery'
export const AUTHENTICATION_SIGN_IN = '/auth'
